import type { ReactNode } from 'react';
import { useState } from 'react';
import { RouterLink } from '@redux-first-router-link';
import { format } from 'date-fns';

import { Modal, Button } from '@simplywallst/ui-core/next';

import type { PortfolioUpdate } from './useUpdates';

import { EventsEducationalContent } from '@/components/EducationalContent';

type Props = PortfolioUpdate & {
  children: ReactNode;
};

export const Event = ({
  children,
  title,
  company,
  keyDevTypeId,
  announcementDate,
  description,
}: Props) => {
  const [state, setState] = useState(false);
  return (
    <>
      <button
        role="listitem"
        aria-label={title}
        onClick={() => setState(true)}
        className="grid items-start text-left"
      >
        {children}
      </button>
      <Modal
        title={
          <span className="text-base font-strong">
            <RouterLink noUnderline to={company.canonicalURL}>
              {company.tickerSymbol}
            </RouterLink>
            <span className="mx-x1 text-softer">|</span>
            {company.name}
          </span>
        }
        isOpen={state}
        onClose={() => setState(false)}
        className="max-w-[600px] lg:min-w-[650px] lg:max-w-[650px]"
      >
        <Modal.Body className="text-sm [&_ul]:mt-x3 [&_ul]:pl-[18px] [&_ul_li]:mb-x1_5 [&_ul_li]:list-disc [&_ul_ul]:mt-auto [&_ul_ul_li]:mb-x1_5 [&_ul_ul_li]:list-[circle]">
          {announcementDate && (
            <span className="text-soft">
              {format(announcementDate, 'MMM d, yyyy')}
            </span>
          )}
          <h2 className="mb-x2 mt-0 text-lg">{title}</h2>
          <p className="m-0">{description}</p>
          {keyDevTypeId && <EventsEducationalContent subType={keyDevTypeId} />}
        </Modal.Body>
        <Modal.Actions>
          <Button variant="primary" onClick={() => setState(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
